import React from 'react';
import {Link} from 'react-router-dom';

import {Exception} from '../Services/ExceptionService';

interface ExceptionPanelProps {
  exception: Exception;
  showInner: boolean;
}

function ExceptionPanel({exception, showInner}: ExceptionPanelProps) {
  let stackTrace = null;
  if (exception.stackTrace !== undefined) {
    stackTrace = (
      <div className="row">
        <label className="col-sm-2">Stack Trace</label>
        <div className="col-sm-10">
          {exception.stackTrace}
        </div>
      </div>
    );
  }

  let innerException = null;
  if (showInner && exception.innerError !== null) {
    innerException = (
      <div className="row">
        <label className="col-sm-2">Inner Exception</label>
        <div className="col-sm-10">
          <ExceptionPanel exception={exception.innerError} showInner />
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="row">
        <label className="col-sm-2">ID</label>
        <div className="col-sm-10">
          <Link to={`/admin/errors/${exception.id}`}>{exception.id}</Link>
        </div>
      </div>
      <div className="row">
        <label className="col-sm-2">Date</label>
        <div className="col-sm-10">
          {exception.date}
        </div>
      </div>
      <div className="row">
        <label className="col-sm-2">Message</label>
        <div className="col-sm-10">
          {exception.message}
        </div>
      </div>
      <div className="row">
        <label className="col-sm-2">Notes</label>
        <div className="col-sm-10">
          {exception.notes}
        </div>
      </div>
      {stackTrace}
      {innerException}
    </div>
  );
}

export default ExceptionPanel;
